<!-- @format -->

@if (review()) {
	<div
		class="hmf-body-m hmf-mb-xs">
		<div
			[highlightKeyword]="highlightedWord()"
			[attr.id]="'reviewText_' + review().Id"
			class="line-clamp"
			[class.review-text-larger-font]="chainAbbr() === 'gg'"
			[class.review-text]="chainAbbr() !== 'gg'">
			{{ review().ReviewText }}
		</div>
		<button
			hmf-action-text
			class="review-action-button"
			[attr.id]="'viewMoreButton_' + review().Id"
			variant="tertiary"
			[attr.aria-label]="'View More for ' + review().Title"
			(click)="toggleExpandedReview()">
			View More
		</button>
	</div>
}
